
import { defineComponent, ref, computed, watch, getCurrentInstance, nextTick } from 'vue'
import useRouter from '../../../../../hooks/useRouter'
import BaseInputOutlined from '../../../../inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../../../inputs/CustomActivatorSelect.vue'
import { CHANGE_BOT_TRIGGER_TYPES } from '@root/src/vars/GCB2'
import TimeInput from '@root/src/components/inputs/TimeInput.vue'
import { CONNECTOR_TYPES } from '@root/src/vars/general'

export default defineComponent({
    name: 'TriggerTypeStep',
    components: { BaseInputOutlined, CustomActivatorSelect, TimeInput },
    props: {
        value: { type: Object, required: true },
        mode: {
            type: String,
            required: true,
        },
        sendToStaff: {
            type: Boolean,
            required: false,
        },
        sendByHrBot: {
            type: Boolean,
            required: false,
        },
        triggerIdFromQuery: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        CHANGE_BOT_TRIGGER_TYPES,
    }),
    setup(props, { emit }) {
        const root = getCurrentInstance().proxy
        const { route } = useRouter(root)
        const project = computed(() => root.$store.getters.projectById(route.value.params.id))
        const isUpdating = ref(false)

        const hasYcConnector = computed(() => {
            return project.value.connectors.some(
                connector => connector.connectorType === CONNECTOR_TYPES.yClients
            )
        })
        const hasHrBotBranchConnector = computed(() => {
            return project.value.connectors.some(
                connector => connector.connectorType === CONNECTOR_TYPES.telegramHrBranch
            )
        })

        const updateTriggerText = (newText: string) => {
            if (isUpdating.value) return
            isUpdating.value = true
            const updatedValue = { ...props.value, text: newText }
            emit('input', updatedValue)
            emit('update-trigger', updatedValue)
            setTimeout(() => {
                isUpdating.value = false
            }, 100)
        }

        const updateTextWithNextTick = (text: string) => {
            nextTick(() => {
                updateTriggerText(text)
            })
        }

        const triggerTypeList = ref([
            { id: 'recordCreated', name: 'Новая запись' },
            // {
            //     id: 'recordCreatedNew',
            //     name: 'Новая запись для клиентов, которые никогда не были в салоне',
            // },
            // {
            //     id: 'recordCreatedPrev',
            //     name: 'Новая запись для клиентов, у которых был хотя бы 1 визит',
            // },
            { id: 'staffChanged', name: 'Изменение записи' },
            { id: 'timeChanged', name: 'Перенос времени записи' },
            { id: 'clientCome', name: 'Клиент пришёл' },
            { id: 'recordDeleted', name: 'Отмена записи' },
            { id: 'recordConfirmed', name: 'Подтверждение записи' },
            { id: 'clientComeAndPaid', name: 'Запрос оценки визита' },
            { id: 'notificationBefore1Day', name: 'Запрос подтверждения за сутки' },
            { id: 'notificationBefore2Hours', name: 'Напоминание за 2 часа' },
        ])
        const clear = () => {
            props.value.event = null
            props.value.customDelay = '00:00:00'
            props.value.sendToStaff = false
            props.value.sendByHrBot = false
        }
        watch(
            () => props.value.event,
            (v, oldV) => {
                // Пропускаем срабатывание при инициализации, если значение не изменилось
                if (v === oldV && oldV !== undefined) return
                
                if (props.triggerIdFromQuery.startsWith('custom_')) {
                    if (v === 'notificationBefore1Day') {
                        if(!props.value.answersList) {
                            props.value.answersList = {
                                '1': ['1', 'ок', 'подтверждаю', 'да', 'хорошо', 'буду'],
                                '2': ['2', 'отмените', 'не приду'],
                            }
                        }                        
                    }
                    if (v === 'clientComeAndPaid') {
                        if(!props.value.answersStatus) {
                            props.value.answersStatus = 'on'
                        }                        
                        if(!props.value.reactions || !props.value.answers || !props.value.answersList) {
                            props.value.reactions = {
                                '1': ['claim', 'message'],
                                '2': ['claim', 'message'],
                                '3': ['claim', 'message'],
                                '4': ['message'],
                                '5': ['message'],
                            }
                            props.value.answers = {
                                '1':
                                    'Очень жаль, что визит вам не понравился. Мы уже сообщили об этом руководству.',
                                '2':
                                    'Очень жаль, что визит вам не понравился. Мы уже сообщили об этом руководству.',
                                '3':
                                    'Очень жаль, что визит вам не понравился. Мы уже сообщили об этом руководству.',
                                '4': 'Очень рады, что вам понравилось!',
                                '5': 'Очень рады, что вам понравилось!',
                            }
                            props.value.answersList = {
                                '1': ['1', '1-', '1+', '0', '0-', '0+', '1!', '0!', '1.'],
                                '2': ['2', '2+', '2-', '2', '2.'],
                                '3': ['3', '3+', '3-', '3', '3.'],
                                '4': ['4', '4+', '4', '4!', '4.'],
                                '5': ['5', '5+', '5-', '5!', '5.', '6', '10', '10!', '555555', '5!!'],
                            }
                        }                       
                    } else {
                        if (!props.value.answersStatus) {
                            props.value.answersStatus = 'off'
                        }                        
                    }
                    // Вызываем emit только если sendByHrBot действительно нужно изменить
                    if (v !== 'notificationBefore2Hours' && hasHrBotBranchConnector.value && props.value.sendByHrBot !== false) {
                        nextTick(() => {
                            const updatedValue = { ...props.value, sendByHrBot: false }
                            emit('input', updatedValue)
                        })
                    }
                    if (!v) {
                        emit('validation-updated', false)
                    } else {
                        emit('validation-updated', true)
                    }
                }
            },
            { deep: true, immediate: true }
        )
        watch(
            () => props.sendToStaff,
            (v, oldV) => {
                // Пропускаем срабатывание при инициализации, если значение не изменилось
                if (v === oldV && oldV !== undefined) return
                
                if (v === true && props.value.event === 'notificationBefore2Hours' && props.mode === CHANGE_BOT_TRIGGER_TYPES.create) {
                    const string = `🗓 *{дата-и-время}*
👤 *{имя-клиента}*
✂️ *{названия-услуг}*

🔄 Частота визитов: *{цикл-возврата}*

➕ *Доп. услуги:*
{дополнительные-услуги}
📅 Последний раз: *{дата-последнего-визита}* ({месяцев-с-последней-покупки})

🛍 *Товары:*
{товары}
📅 Последний раз: *{дата-последней-покупки}* ({месяцев-с-последней-покупки})`
                    updateTextWithNextTick(string)
                } else if (v === false && props.mode === CHANGE_BOT_TRIGGER_TYPES.create) {
                    updateTextWithNextTick('')
                    if (hasHrBotBranchConnector.value && props.value.sendByHrBot !== false) {
                        nextTick(() => {
                            const updatedValue = { ...props.value, sendByHrBot: false }
                            emit('input', updatedValue)
                        })
                    }                    
                }
            },
            { immediate: true, deep: true }
        )
        const updateTime = (val: number, key: string) => {
            emit('input', Object.assign({}, props.value, { [key]: val }))
        }
        return {
            clear,
            triggerTypeList,
            updateTime,
            hasYcConnector,
            updateTriggerText,
            hasHrBotBranchConnector
        }
    },
})
